const fontSizeList = [12, 14, 16, 18, 20, 24, 26, 30, 32].map((item) => ({
    label: `${item}px`,
    value: `${item}px`,
}));
export const defaultOption = {
    default: '14px',
    options: fontSizeList,
};
//# sourceMappingURL=data.js.map